import format from "date-fns/format";
import Link from "next/link";
import { useRouter } from "next/router";
import logger from "../../core/logger";
import { IProcedureDetails } from "../../typings/filterEntities";
import Heading from "../Heading/Heading";
import { ArrowIcon, AvatarPlaceholderIcon, industryIconMap } from "../Icons/Icons";
import styles from "./ProcedureHeader.module.css";

interface IProps {
  procedure: IProcedureDetails;
}

// TODO: choose an appropriate cutoff
// const DOWNLOAD_CUTOFF = 50;

export default function ProcedureHeader({ procedure }: IProps) {
  const { title, topic, industry, listingDate, maintainer, introduction } = procedure;

  const router = useRouter();

  const IndustryIcon = industryIconMap[industry.slug];
  const formattedDate = format(new Date(listingDate), "P");

  function handleGoBack() {
    if (window.history.length > 2) {
      router.back();
    } else {
      // fallback to GPL home if no browser history, see https://stackoverflow.com/a/3588420/564163
      router.push("/").catch((err) => {
        logger.error(err);
      });
    }
  }

  return (
    <header>
      <a className={styles.back} onClick={handleGoBack}>
        <ArrowIcon direction="left" /> Back
      </a>
      <div className={styles.taxonomies}>
        <Link href={`/${industry.slug}`} className={styles.taxonomyLink}>
          {IndustryIcon && <IndustryIcon width={14} height={14} />} {industry.label}
        </Link>
        <span> • </span>
        <Link href={`/${industry.slug}/${topic.slug}`} className={styles.taxonomyLink}>
          {topic.label}
        </Link>
      </div>
      <Heading component="h1" variant="h2">
        {title}
      </Heading>
      <div className={styles.description}>{introduction}</div>
      <div className={styles.meta}>
        <div className={styles.maintainerImageWrapper}>
          {maintainer?.thumbnail.originalUrl ? (
            <img
              className={styles.maintainerImage}
              src={maintainer?.thumbnail.originalUrl}
              width={56}
              height={56}
            />
          ) : (
            <AvatarPlaceholderIcon width={56} height={56} />
          )}
        </div>
        <div>
          <div className={styles.maintainerName}>{maintainer?.name}</div>
          <div className={styles.date}>
            {formattedDate}
            {/* TODO: Show the download count later on (when GPL is actively used) */}
            {/* {!!downloadCount && downloadCount >= DOWNLOAD_CUTOFF && (
              <>
                {" "}
                • {downloadCount} <DownloadIcon width={16} height={16} />
              </>
            )} */}
          </div>
        </div>
      </div>
    </header>
  );
}
